import { RouteRecordRaw, RouterView } from "vue-router";

const bookingsRoutes: RouteRecordRaw = {
  path: "/bookings",
  component: () => import(/* webpackChunkName: "bookings-layout" */ "../layouts/BookingsLayout.vue"),
  meta: { requiresAuth: true, title: "bookings" },
  children: [
    {
      path: "",
      component: RouterView,
      name: "bookings",
      children: [
        {
          path: "",
          name: "bookingsHome",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingsHomeView.vue"),
        },
        {
          path: "types/:bookingTypeUuid/categories",
          name: "bookingCategories",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingCategoriesView.vue"),
          props: true,
        },
        {
          path: "categories/:categoryUuid/sub-categories",
          name: "bookingSubCategories",
          component: () =>
            import(
              /* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingSubCategoriesView.vue"
            ),
          props: true,
        },
        {
          path: "sub-categories/:subCategoryUuid/products",
          name: "bookingProductsBySubCategory",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingProductsView.vue"),
          props: true,
        },
        {
          path: "categories/:categoryUuid/products",
          name: "bookingProductsByCategory",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingProductsView.vue"),
          props: true,
        },
        {
          path: "search",
          name: "bookingProductsSearch",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingProductsView.vue"),
          props: (route) => ({
            initialSearch: typeof route.query.q === "string" ? route.query.q : "",
            globalSearch: true,
          }),
        },
        {
          path: "products/:productUuid",
          name: "bookingProductDetail",
          component: () =>
            import(
              /* webpackChunkName: "bookings-employee-catalog" */ "../views/employee/BookingProductDetailView.vue"
            ),
          props: true,
        },

        {
          path: "cart",
          name: "bookingCart",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-checkout" */ "../views/employee/BookingCartView.vue"),
        },
        {
          path: "checkout",
          name: "bookingCheckout",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-checkout" */ "../views/employee/BookingCheckoutView.vue"),
        },
        {
          path: "confirmation",
          name: "bookingConfirmation",
          component: () =>
            import(
              /* webpackChunkName: "bookings-employee-checkout" */ "../views/employee/BookingConfirmationView.vue"
            ),
        },

        {
          path: "my-reservations",
          name: "myBookings",
          component: () =>
            import(/* webpackChunkName: "bookings-employee-reservations" */ "../views/employee/MyBookingsView.vue"),
        },
        {
          path: "my-reservations/:reservationUuid",
          name: "myBookingDetail",
          component: () =>
            import(
              /* webpackChunkName: "bookings-employee-reservations" */ "../views/employee/MyBookingDetailView.vue"
            ),
          props: true,
        },
      ],
    },
    {
      path: "admin",
      component: RouterView,
      meta: { requiresAdminRole: true },
      children: [
        {
          path: "",
          name: "bookingsAdminHome",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-core" */ "../views/admin/BookingsAdminDashboard.vue"),
        },
        {
          path: "reservations",
          name: "adminBookings",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-core" */ "../views/admin/AdminReservationsView.vue"),
        },
        {
          path: "reservations/:reservationUuid",
          name: "adminBookingDetail",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-core" */ "../views/admin/AdminReservationDetailView.vue"),
          props: true,
        },

        {
          path: "inventory",
          name: "adminInventory",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-inventory" */ "../views/admin/AdminInventoryView.vue"),
        },
        {
          path: "products/:productUuid/units",
          name: "adminProductUnits",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-inventory" */ "../views/admin/AdminProductUnitsView.vue"),
          props: true,
        },
        {
          path: "units/:unitUuid",
          name: "adminUnitDetail",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-inventory" */ "../views/admin/AdminUnitDetailView.vue"),
          props: true,
        },
        {
          path: "units/:unitUuid/history",
          name: "adminUnitHistory",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-inventory" */ "../views/admin/AdminUnitHistoryView.vue"),
          props: true,
        },
        {
          path: "maintenance",
          name: "adminMaintenance",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-inventory" */ "../views/admin/AdminMaintenanceView.vue"),
        },
        {
          path: "analytics",
          name: "adminAnalytics",
          component: () =>
            import(/* webpackChunkName: "bookings-admin-reports" */ "../views/admin/AdminAnalyticsView.vue"),
        },
      ],
    },
  ],
};

export default bookingsRoutes;
